/**
 * 环境变量集中读取，禁止在业务代码中直接使用 import.meta.env
 */
export const env = {
  /** 应用标题 */
  appTitle: import.meta.env.VITE_APP_TITLE || '记单词管理后台',
  /** 接口前缀，如 /api */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  /** 文件上传地址 */
  uploadUrl: import.meta.env.VITE_UPLOAD_URL || '/api/v1/upload',
  /** 是否启用 mock */
  useMock: import.meta.env.VITE_USE_MOCK === 'true',
  /** 是否开发环境 */
  isDev: import.meta.env.DEV,
  /** 是否生产环境 */
  isProd: import.meta.env.PROD,
  /** 当前模式 */
  mode: import.meta.env.MODE,
} as const

export default env
